// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"fe0d80af","213":"2cb51220","453":"757c9f21","590":"6f830e91","667":"8269ec65","677":"38684d1d","706":"632b37a8","728":"8eeae6f7","942":"0f5c41fe","968":"22c86371"}[chunkId] + ".chunk.js";
};